import React, { FC } from 'react';
import { PerformanceMenuProps } from '@v2/pages/machines/common/components/Header/MachinesHeaderV2/types';
import { useSelector } from 'react-redux';
import { selectFeatureFlags } from '@reducers/user';
import { FeatureFlagsAvailable } from '@components/featureFlags';
import { TourTarget } from '@components/tours';
import { WELCOME_TOUR_IDS } from '@components/tours/config/global/welcome';
import { isPhone } from '@helpers';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { HEADER_MOBILE_GAP_BETWEEN_LEVELS } from '@v2/pages/common/constants/base.constants';
import { navigationLevels } from '@v2/pages/machines/common/constants';
import { NavLink } from './NavLink';
import { TimePeriodMenu } from './TimePeriodMenu';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { MachinesScreen } from '@v2/pages/machines/common/enums';

const PerformanceMenu: FC<PerformanceMenuProps> = ({ rowStyles, nested, checkIsSelected, onPress }) => {
  const featureFlags = useSelector(selectFeatureFlags);

  const shouldDisplayPaid = !nested && FeatureFlagsAvailable('machine-paid', featureFlags);

  return (
    <>
      <TourTarget tourId={WELCOME_TOUR_IDS.PERFORMANCE_TABS}>
        <View style={[rowStyles, isPhone && { paddingBottom: scale(HEADER_MOBILE_GAP_BETWEEN_LEVELS) }]}>
          {Object.values(nested ? navigationLevels.contextHeaderMetricTypes : navigationLevels.metricTypes).map((title) => {
            if (!shouldDisplayPaid && title === navigationLevels.metricTypes.paid) return;
            const performanceMenuTestIDs: Record<string, string> = {
              [MachinesScreen.UTILIZATION]: TEST_IDS.machinesHeader.performanceMenuUtilization,
              [MachinesScreen.ACTIVE]: TEST_IDS.machinesHeader.performanceMenuActive,
              [MachinesScreen.PRODUCTIVE]: TEST_IDS.machinesHeader.performanceMenuProductive,
              [MachinesScreen.PAID]: TEST_IDS.machinesHeader.performanceMenuPaid,
            };

            return <NavLink key={title} title={title} selected={checkIsSelected(title)} onPress={() => onPress(title)} testID={performanceMenuTestIDs[title]} />;
          })}
        </View>
      </TourTarget>
      <TimePeriodMenu rowStyles={rowStyles} shouldDisplayEightWeeks />
    </>
  );
};

export { PerformanceMenu };
